import React, { useState } from "react";
import AppConfig from "./common/AppConfig";
import "react-phone-input-2/lib/style.css";
import PhoneNumber from "./components/phoneNumber/PhoneNumber";
import "./loginStyle.scss";
import InputTextField from "./components/textField/InputTextField";
import Button from "./components/button/Button";
import logo from "./images/siteLogo.png";
import { Link } from "react-router-dom";
const Register = () => {
  const [number, setNumber] = useState("us");
  return (
    <div className="register">
      <div className="login">
        <div className="loginImg">
          <img src={logo} alt="logo" className="siteLogo" />
        </div>
        <div className="formContainer filedWidth">
          <form className="form">
            <div className="formTitle">
              <h2>Register</h2>
              <p>
                Create an account here.
              </p>
            </div>
            <div className="fields">
              <InputTextField
                label="Full Name"
                variant="outlined"
                placeholder="Enter your Name"
                type="text"
                width="384px"
              />

              <InputTextField
                label="Email Address"
                variant="outlined"
                placeholder="Example@mail.com"
                type="text"
                width="384px"
              />

              <PhoneNumber
                counter={number}
                placeholder="Phone Number"
                onChange={(value) => {
                  setNumber(value);
                }}
              />

              <InputTextField
                label="Customer No."
                variant="outlined"
                placeholder="Customer No."
                type="number"
                width="384px"
              />

              <InputTextField
                label="Password"
                variant="outlined"
                placeholder="at least 8 characters"
                width="384px"
                type="password"
              />

              <InputTextField
                label="Confirm Password"
                variant="outlined"
                placeholder="at least 8 characters"
                width="384px"
                type="password"
              />
            </div>

            <Button text="Register" type="submit" width="true" />

            <div className="register">
              <p>Already have an account?</p>
              <Link
                to={`${AppConfig.orderFormPath}/login`}
                className="registerText"
              >
                <span> Login Now</span>
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Register;
